import { useState } from 'react';
import { Popover } from 'react-tiny-popover';
import styled from 'styled-components';

type Props = {
  options: { name: string; logo: string }[];
  selectedIndex: number;
  setSelectedIndex: (index: number) => void;
};

function DropdownArrow() {
  return (
    <svg width="12" height="6.75" viewBox="0 0 445 267" fill="none">
      <path
        d="M444.427 42.8L401.864 0.982666L224.157 182.423L42.7173 4.716L0.905273 48.0227L225.652 266.796L444.427 42.8Z"
        fill="white"
      />
    </svg>
  );
}

function Option({ text, onClick, logo }: { text: string; onClick: () => void; logo: string }) {
  return (
    <OptionSelector style={{ border: 'none' }} onClick={onClick}>
      <LogoImage src={logo} />
      {text}
    </OptionSelector>
  );
}

function RewardsChainSelector({ options, selectedIndex, setSelectedIndex }: Props) {
  const selected = options[selectedIndex];

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const onClickOutside = () => setIsPopoverOpen(false);

  return (
    <Popover
      isOpen={isPopoverOpen}
      positions={['bottom', 'right']}
      padding={12}
      onClickOutside={onClickOutside}
      containerStyle={{ zIndex: '1000' }}
      content={
        <Options>
          {options.map((option, index) => (
            <Option
              key={index}
              text={option.name}
              logo={option.logo}
              onClick={() => {
                setSelectedIndex(index);
                setIsPopoverOpen(false);
              }}
            />
          ))}
        </Options>
      }
    >
      <MainSelector onClick={() => setIsPopoverOpen(!isPopoverOpen)}>
        {selected.name}
        <DropdownArrow />
      </MainSelector>
    </Popover>
  );
}

const Selector = styled.div`
  border-radius: 6px;
  // gray border
  border: 1px solid #c9c9c9;

  font-size: 14px;
  // color: #c9c9c9;
  color: white;
  padding: 8px 16px;

  &:hover {
    cursor: pointer;
    border: 1px solid #ffffff;
    background-color: rgba(255, 255, 255, 0.1);
  }

  transition: all 0.2s ease-in-out;

  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const MainSelector = styled(Selector)`
  margin-top: 16px;
  margin-bottom: 16px;
`;

const OptionSelector = styled(Selector)`
  border: none;
`;

const Options = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  background-color: rgba(15, 16, 22, 0.9);

  // add background blur
  backdrop-filter: blur(10px);
  padding: 8px;
  border-radius: 6px;
  border: 1px solid #c9c9c9;
`;

const LogoImage = styled.img`
  height: 24px;
  width: 24px;
`;
export default RewardsChainSelector;
